import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { ProjectMinimal } from "../utils/backend-types";

export function useProjects({
  options,
  isFilterActive
}: {
  options?: Partial<UseQueryOptions<Array<ProjectMinimal>>>;
  isFilterActive?: boolean;
}) {
  return useQuery({
    queryKey: ["projects-list", isFilterActive],
    queryFn: () => fetchProjects(isFilterActive),
    staleTime: 60 * 1000, // 1 minute
    ...options
  });
}

async function fetchProjects(isFilterActive?: boolean) {
  const response = await api.get<Array<ProjectMinimal>>(
    urls.api.projectsList(isFilterActive)
  );
  return response.data;
}
